import { BadgeProps } from "@/components/ui/badge";
import {
  LocalizedText,
  SystemMessage,
  SystemMessageDisplayType,
  SystemMessageType
} from "@/models/system-message";

type BadgeVariant = BadgeProps["variant"];

export const TYPE_LABELS: Record<SystemMessageType, string> = {
  info: "Info",
  announcement: "Announcement",
  success: "Success",
  warning: "Warning",
  urgent: "Urgent"
};

export const TYPE_BADGE_VARIANT: Record<SystemMessageType, BadgeVariant> = {
  info: "info",
  announcement: "default",
  success: "success",
  warning: "warning",
  urgent: "destructive"
};

export const TYPE_ORDER: SystemMessageType[] = [
  "info",
  "announcement",
  "success",
  "warning",
  "urgent"
];

export const DISPLAY_TYPE_LABELS: Record<SystemMessageDisplayType, string> = {
  banner: "Banner",
  popup: "Popup",
  both: "Banner + Popup"
};

export const DISPLAY_TYPE_ORDER: SystemMessageDisplayType[] = ["banner", "popup", "both"];

export type SystemMessageStatus = "active" | "scheduled" | "expired" | "disabled";

export const STATUS_LABELS: Record<SystemMessageStatus, string> = {
  active: "Active",
  scheduled: "Scheduled",
  expired: "Expired",
  disabled: "Disabled"
};

export const STATUS_BADGE_VARIANT: Record<SystemMessageStatus, BadgeVariant> = {
  active: "success",
  scheduled: "secondary",
  expired: "outline",
  disabled: "outline"
};

// Mirrors the read-side filter in the backend's findActive() — computed
// client-side here since the admin list needs to show every status,
// not just the currently-active set.
export const getSystemMessageStatus = (
  message: Pick<SystemMessage, "enabled" | "startAt" | "endAt">,
  now: Date = new Date()
): SystemMessageStatus => {
  if (!message.enabled) return "disabled";
  if (message.startAt && new Date(message.startAt) > now) return "scheduled";
  if (message.endAt && new Date(message.endAt) < now) return "expired";
  return "active";
};

// The admin UI is English-only, so prefer English and fall back to Arabic.
export const displayText = (text?: LocalizedText | null): string =>
  text?.en?.trim() || text?.ar?.trim() || "";
